import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';

import {
  TXTCLI_Exchange_1,
  TXTWCL_Sportsbook
} from './PokerStarsExchangeToggleWidget.messages.json';
import styles from './PokerStarsExchangeToggleWidget.scss';
import ExchangeIcon from './assets/exchange-arrows.svg';
import SportsIcon from './assets/football.svg';
import useIsExchange from './hooks/useIsExchange';
import Toggle from './toggle/index';

enum Options {
  sports = 'sports',
  exchange = 'exchange'
}

const PokerStarsExchangeToggleWidget: WidgetFC = () => {
  const isExchangeEnabled = useFeature(FeatureFlag.EnableExchange);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const history = useHistory();
  const [isExchange] = useIsExchange();
  const getURLValue = (isExchange: boolean) => (isExchange ? Options.exchange : Options.sports);
  const [value, setValue] = useState(getURLValue(isExchange));
  const aliases = useSelector(select.cms.getAliases);

  const handleChange = useCallback(
    (val: Options) => {
      setValue(val);
      const path = val === Options.exchange ? aliases.sportsExchange : aliases.sportsHome;
      history.push(path || '/');
    },
    [aliases, history]
  );

  useEffect(() => setValue(getURLValue(isExchange)), [isExchange]);

  if (!isExchangeEnabled || isEmbedded) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <Toggle onChange={handleChange as (value: string) => void} value={value}>
          <Toggle.Option value={Options.sports} icon={<SportsIcon />}>
            <Translation {...TXTWCL_Sportsbook} />
          </Toggle.Option>
          <Toggle.Option value={Options.exchange} icon={<ExchangeIcon />}>
            <Translation {...TXTCLI_Exchange_1} />
          </Toggle.Option>
        </Toggle>
      </div>
    </div>
  );
};

export default PokerStarsExchangeToggleWidget;
